import {
  type ShippingRateTable,
  ShippingRateTableArraySchema,
  type SkippedZone,
  SkippedZoneSchema,
} from "@redotech/redo-model/integration/redo-in-shipping/shipping-rate-table";
import { DeliveryProfileSchema } from "@redotech/redo-model/integration/shopify/delivery-profile";
import * as z from "zod/v4";

export interface GetRateTablesFromDeliveryProfileOutput {
  rateTables: ShippingRateTable[];
  skippedZones: SkippedZone[];
}

const GetRateTablesFromDeliveryProfileOutputSchema_: z.ZodType<GetRateTablesFromDeliveryProfileOutput> =
  z.object({
    rateTables: ShippingRateTableArraySchema,
    skippedZones: z.array(SkippedZoneSchema),
  });

export interface GetRateTablesFromDeliveryProfileDef {
  name: "getRateTablesFromDeliveryProfile";
  input: z.ZodObject<{
    deliveryProfile: typeof DeliveryProfileSchema;
    hasPackageProtection: z.ZodBoolean;
    hasReturnCoverage: z.ZodBoolean;
    hasCarrierServices: z.ZodBoolean;
    teamId: z.ZodString;
  }>;
  output: typeof GetRateTablesFromDeliveryProfileOutputSchema_;
}

export const getRateTablesFromDeliveryProfile: GetRateTablesFromDeliveryProfileDef =
  {
    name: "getRateTablesFromDeliveryProfile" as const,
    input: z.object({
      deliveryProfile: DeliveryProfileSchema,
      hasPackageProtection: z.boolean(),
      hasReturnCoverage: z.boolean(),
      hasCarrierServices: z.boolean(),
      teamId: z.string(),
    }),
    output: GetRateTablesFromDeliveryProfileOutputSchema_,
  };
